// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
export const windowSize = {
  util: {
    valueMatches: (documentWidth, operation, breakpoint) => {
      let match;
      switch (operation) {
        case '<':
          match = documentWidth < breakpoint;
          break;
        case '>':
          match = documentWidth > breakpoint;
          break;
        case '=':
          match = documentWidth === breakpoint;
          break;
      }
      return match;
    },
  },
};
